import domReady from '@wordpress/dom-ready';

domReady(() => {
  let previousIndices = [];

  const updateContentOrder = () => {
    const blocks = Array.from(
      document.querySelectorAll('.loading-spinner__content .card-item-loading')
    );

    blocks.forEach((block) => {
      block.classList.remove('visible');
      block.style.order = 'unset';
      block.style.transform = 'none';
    });

    const total = blocks.length;
    if (total < 2) return;

    const indices = new Set();
    while (indices.size < 2) {
      const rand = Math.floor(Math.random() * total);
      if (!previousIndices.includes(rand)) {
        indices.add(rand);
      }
    }

    previousIndices = [...indices];

    [...indices].forEach((index, i) => {
      const block = blocks[index];
      block.classList.add('visible');
      block.style.order = i === 0 ? '1' : '3';
      block.style.transform =
        i === 0
          ? 'rotate(-5deg) translateX(30px)'
          : 'rotate(5deg) translate(-30px, -200px) ';
    });
  };

  updateContentOrder();
  setInterval(updateContentOrder, 15000);

  // Animation for the loading percentage
  const percent = document.getElementById('percent');
  let start = null;

  function animate(timestamp) {
    if (!start) start = timestamp;
    const progress = (timestamp - start) % 15000;
    const percentValue = Math.floor((progress / 15000) * 100);
    percent.textContent = percentValue + '%';
    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
});
